module.exports = __webpack_public_path__ + "img/inter3.bb18471a.jpg";